import { currentSubscriptionMapper, subscriptionNameMapping } from '../mappers/current-subscription-mapper';
import { subscriptionPlanMapper } from '../mappers/subscription-plan-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';

const subscriptionRepository = {
    async getPlans() {
        try {
            const plans = await apiClient.get({
                url: 'subscriptions/plans',
                isCheckAccessToken: true
            });

            return plans.map(subscriptionPlanMapper.toDomain).filter(Boolean);
        } catch (error) {
            logError(error);

            return [];
        }
    },

    async getCurrent() {
        try {
            const subscriptionData = await apiClient.get({
                url: 'subscriptions',
                isCheckAccessToken: true
            });

            return currentSubscriptionMapper.toDomain(subscriptionData);
        } catch (error) {
            logError(error);

            return [];
        }
    },

    async create(body) {
        try {
            const plan = await apiClient.post({
                url: 'subscriptions',
                body,
                isCheckAccessToken: true
            });

            return plan;
        } catch (error) {
            logError(error);

            throw error;
        }
    },

    async cancel(subscriptionId) {
        try {
            await apiClient.post({
                url: `subscriptions/${subscriptionId}/cancel`,
                isCheckAccessToken: true
            });

            return true;
        } catch (error) {
            logError(error);

            throw error;
        }
    },

    async getStatus(subscriptionId) {
        try {
            const data = await apiClient.get({
                url: `subscriptions/${subscriptionId}/status`,
                isCheckAccessToken: false
            });

            return {
                paymentStatus: data.paymentStatus,
                plan: data.plan,
                id: data.id,
                name: subscriptionNameMapping[data.plan] || 'plan'
            };
        } catch (error) {
            logError(error);

            return {};
        }
    },
};

export {
    subscriptionRepository
}
